<template>
  <div :style="styles.base">
    <div :class="getCss('area')">
      <template v-if="isShowGameForNoBind">
        <img :style="imageStyle" v-src="gameIcon"/>
        <div :style="gameNameStyle">{{ gameName }}</div>
      </template>
      <template v-else>
        <div :style="noGameNameStyle">请选择游戏</div>
      </template>
      <c-button ref="button"
                :style="buttonStyle"
                :text="buttonText"
                v-bind="$props"
      >
      </c-button>
    </div>
    <c-dialog
      v-model="isShow"
      :option="option"
      @close="isShow = false"
      @confirm="switchGame"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('dialog-body')">
          <div :class="getCss('dialog-wrap-three')">
          <template v-for="(game, index) in gameList">
              <div
                v-if="index < 3" :key="index"
                @click="switchGameCode = game.game_code"
                :style="selectGameStyle"
                :class="getCss(
                  ['dialog-item-three', switchGameCode === game.game_code ? 'dialog-switch-item-three' : '']
                )"
              >
                <img :src="game.icon" :class="getCss('dialog-item-game-icon-three')"/>
                <div :class="getCss('dialog-item-game-name-three')">{{ game.game_name }}</div>
              </div>
            </template>
          </div>
          <template v-for="(game, index) in gameList">
            <div
              v-if="index >= 3"
              :key="index"
              @click="switchGameCode = game.game_code"
              :style="selectGameStyle"
              :class="getCss('dialog-wrap')"
            >
              <div :class="getCss(['dialog-item', switchGameCode === game.game_code ? 'dialog-switch-item' : ''])">
                <img :src="game.icon" :class="getCss('dialog-item-game-icon')"/>
                <div :class="getCss('dialog-item-game-name')">{{ game.game_name }}</div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </c-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
// import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';

export default {
  name: 'CPublicSwitchGame',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-switch-game-',
      gameList: [],
      selectedGameName: '', // 已切换游戏
      selectedGameIcon: '', // 已切换游戏
      selectedGid: '', // 已切换游戏
      selectedGameCode: '', // 已切换游戏
      isShow: false,
      switchGameCode: '', // 弹窗选中的gameCode
      whiteGameMap: {},
      gameIcon: '', // 页面展示的游戏，会判断默认游戏优先级
      gameName: '', // 页面展示的游戏，会判断默认游戏优先级
      gid: '', // 页面展示的游戏，会判断默认游戏优先级
      gameCode: '', // 页面展示的游戏，会判断默认游戏优先级
    };
  },
  computed: {
    /**
     * 链接上的gid
     * @returns {string|number}
     */
    linkGid() {
      const { isGetDefaultGameFromLink = false } = this.configurationData;
      const gidFromLink = Number(common.tool.getQueryParams('gid'));
      if (isGetDefaultGameFromLink && Number.isFinite(gidFromLink)) return gidFromLink;
      return '';
    },
    /**
     * 默认游戏
     * 游戏未开放不处理
     * @returns {{gid: string, gameName: string, gameCode: string, gameIcon: string}
     * |{gid: *, gameName: *, gameCode: *, gameIcon: *}}
     */
    defaultGame() {
      const gameItemFromLink = this.gameList.find(e => e?.gid === this.linkGid);
      if (Number.isFinite(this.linkGid) && gameItemFromLink && this.isInWhiteGameMap(this.linkGid)) {
        const { icon: gameIcon, game_name: gameName, gid, game_code: gameCode } = gameItemFromLink;
        return { gameIcon, gameName, gid, gameCode };
      }
      if (this.gameList.length > 0) {
        for (const gameItem of this.gameList) {
          console.log('【CPublicSwitchGame】defaultGame this.gameList gameItem = ', gameItem);
          const { icon: gameIcon, game_name: gameName, gid, game_code: gameCode } = gameItem;
          if (this.isInWhiteGameMap(gid)) {
            return { gameIcon, gameName, gid, gameCode };
          }
        }
      }
      const gameItemFromActInfo = this.gameList.find(e => e?.gid === this.actInfo.gid);
      if (gameItemFromActInfo) {
        const { icon: gameIcon, game_name: gameName, gid, game_code: gameCode } = gameItemFromActInfo;
        return { gameIcon, gameName, gid, gameCode };
      }
      return { gameIcon: '', gameName: '', gid: '', gameCode: '' };
    },
    imageStyle() {
      const { height } = this.styles.base;
      return {
        width: height,
        height,
      };
    },
    // 未绑定的情况是否展示游戏
    isShowGameForNoBind() {
      if (!this.isLogin) return false;
      if (!Number.isFinite(this.gid)) return false;
      return true;
    },
    gameNameStyle() {
      const { height } = this.styles.base;
      const { color, fontSize, textAlign = 'left' } = this.styles.nameStyle;
      let width;
      switch (this.buttonText.length) {
        case 2:
          width = '80%';
          break;
        case 3:
          width = '75%';
          break;
        default:
          width = '70%';
      }
      return {
        width,
        lineHeight: height,
        height,
        color,
        fontSize,
        textAlign,
      };
    },
    noGameNameStyle() {
      const { height } = this.styles.base;
      const { color, fontSize } = this.styles.nameStyle;
      return {
        lineHeight: height,
        height,
        color,
        fontSize,
        textAlign: 'left',
      };
    },
    buttonStyle() {
      return {
        width: 'fit-content',
        top: 0,
        position: 'static',
        textDecorationLine: 'underline',
        ...this.styles.buttonStyle,
      };
    },
    option() {
      const { dialogHeader = '选择游戏',  dialogCloseLocation = 'top-right', dialogConfirmButtonBackgroundImage, dialogBackgroundImage } = this.configurationData;
      const { color } = this.styles.selectDialogStyle;
      let confirmStyle;
      if (!!dialogConfirmButtonBackgroundImage) {
        confirmStyle = {
          backgroundImage: `url(${dialogConfirmButtonBackgroundImage})`,
          ...this.styles.selectDialogConfirmStyle,
        };
      } else {
        confirmStyle = {
          color,
          backgroundColor: '#000',
          ...this.styles.selectDialogConfirmStyle,
        };
      }
      const selectDialogStyle = { ...this.styles.selectDialogStyle };
      if (!!dialogBackgroundImage) {
        selectDialogStyle.backgroundImage = `url(${dialogBackgroundImage})`;
      }

      return Object.assign({}, this.dialogConfig, {
        header: dialogHeader,
        titleStyle: {
          ...this.styles.selectDialogTitleStyle,
        },
        body: false,
        footer: true,
        confirm: !!dialogConfirmButtonBackgroundImage ? true : '确认选择该游戏',
        close: true,
        closeLocation: dialogCloseLocation,
        width: '7rem',
        height: '8rem',
        dialogStyle: Object.assign({}, this.dialogConfig.dialogStyle, selectDialogStyle),
        confirmStyle: {
          ...confirmStyle,
        },
      });
    },
    buttonText() {
      const { buttonText = '切换游戏' } = this.configurationData;
      return buttonText;
    },
    // 切换游戏是否重新拉角色
    isRefreshRoleInfo() {
      const { isRefreshRoleInfo = false } = this.configurationData;
      return isRefreshRoleInfo;
    },
    isQueryWhiteGameMap() {
      const { queryWhiteGameMapFlowId = 0 } = this.configurationData;
      return queryWhiteGameMapFlowId > 0;
    },
    noInWhiteGameMapTips() {
      const { noInWhiteGameMapTips = '' } = this.configurationData;
      return noInWhiteGameMapTips;
    },
    isInWhiteGameMap() {
      return (gid) => {
        if (!this.isQueryWhiteGameMap) return true;
        return Boolean(this.whiteGameMap[gid]);
      };
    },
    selectGameStyle() {
      return {
        '--select-game-color': `0 0 0.1rem ${this.configurationData.selectGameColor}` || '0 0 0.1rem #000',
      };
    },
  },
  watch: {
    currentGid: {
      handler(val) {
        console.log('【CPublicSwitchGame】 watch currentGid = ', val, ', gid = ', this.gid);
        if (this.gameList.length <= 0) return;
        const gameInfo = this.gameList.find(e => e?.gid === val) || {};
        if (!Number.isFinite(gameInfo?.gid)) return;
        this.selectedGameName = gameInfo?.game_name;
        this.selectedGameIcon = gameInfo?.icon;
        this.selectedGid = gameInfo?.gid;
        this.selectedGameCode = gameInfo?.game_code;
        this.handlerGame();
      },
      immediate: true,
    },
  },
  async mounted() {
    console.log('【CPublicSwitchGame】 configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    // 打开弹窗才会mounted时执行查询流程
    initMounted() {
      this.enterHandlerGame();
    },
    async initialize() {
      if (this.$isInEditor) return;
      this.initMounted();
      this.$onLogined(() => {
        this.enterHandlerGame();
      });
      this.$refs.button.setClickHandler(this.showDialog, {
        forceApp: false,
        forceLogin: true,
        forceRole: false,
      });
    },
    async enterHandlerGame() {
      if (!this.isLogin) return;
      Promise.all([this.queryGameList(), this.queryWhiteGameMap()])
        .then(async ([gameList = [], whiteGameMap = {}]) => {
          console.log('【CPublicSwitchGame】enterHandlerGame query game list = ', gameList, ', whiteGameMap = ', whiteGameMap);
          this.whiteGameMap = whiteGameMap;
          // 查询了游戏白名单，不在白名单内未配置提示语隐藏游戏
          for (const gameItem of gameList) {
            if (
              this.isInWhiteGameMap(gameItem?.gid)
              || (!this.isInWhiteGameMap(gameItem?.gid) && this.noInWhiteGameMapTips)
            ) {
              this.gameList.push(gameItem);
            }
          }
          console.log('【CPublicSwitchGame】enterHandlerGame this.gameList = ', this.gameList);
          // 链接上带gid，就显示这个游戏。会判断gid是否参与活动，并且判断游戏是否开放
          console.log('【CPublicSwitchGame】 enterHandlerGame isInWhiteGameMap = ',  this.isInWhiteGameMap(this.linkGid), ', linkGid = ', this.linkGid);
          if (Number.isFinite(this.linkGid)) {
            const gameItem = this.gameList.find(item => item?.gid === this.linkGid) || {};
            this.handlerSelectedGame(gameItem);
          }
          // 链接上不带gid，或者链接上gid不参与活动
          if (!Number.isFinite(this.selectedGid)) {
            await this.queryBindGame();
          }
          // 如果已绑定gid与页面配置的gid不一致，重新拉取已绑角色信息
          console.log('【CPublicSwitchGame】enterHandlerGame actInfo gid = ', this.$actInfo.gid, ', current selectedGid =', this.selectedGid);
          this.updateGame({
            refreshRoleMs: 1200,
            isRefreshRoleInfo: this.$actInfo.gid !== this.selectedGid,
            isRefreshQua: this.$actInfo.gid !== this.selectedGid,
            isRefreshClub: this.$actInfo.gid !== this.selectedGid,
          });
        })
        .catch((err) => {
          console.error('【CPublicSwitchGame】enterHandlerGame query game error, err = ', err);
        });
    },
    handlerSelectedGame(gameItem = {}) {
      const { game_name: gameName, icon: gameIcon, gid, game_code: gameCode } = gameItem;
      if (Number.isFinite(gid) && this.isInWhiteGameMap(gid)) {
        this.selectedGameName = gameName;
        this.selectedGameIcon = gameIcon;
        this.selectedGid = gid;
        this.selectedGameCode = gameCode;
      }
    },
    handlerGame() {
      console.log('【CPublicSwitchGame】handlerGame defaultGame = ', this.defaultGame);
      this.gameIcon = this.selectedGameIcon ? this.selectedGameIcon : this.defaultGame.gameIcon;
      this.gameName = this.selectedGameName ? this.selectedGameName : this.defaultGame.gameName;
      this.gid = Number.isFinite(this.selectedGid) ? this.selectedGid : this.defaultGame.gid;
      this.gameCode = this.selectedGameCode ? this.selectedGameCode : this.defaultGame.gameCode;
    },
    /**
     * 同步游戏到store
     * @param refreshRoleMs  延迟checkRole
     * @param isRefreshRoleInfo  是否checkRole,默认是执行checkRole,处理刚进入页面与查询已绑定角色与活动配置的游戏一致时就不checkRole
     */
    updateGame({ refreshRoleMs = 0, isRefreshRoleInfo = true, isRefreshQua = true, isRefreshClub = true }) {
      this.handlerGame();
      this.UPDATE_GAME_CODE(this.gameCode);
      this.UPDATE_GID(this.gid);
      console.log('【CPublicSwitchGame】updateGame isRefreshQua = ', isRefreshQua);
      if (isRefreshQua) {
        this.refreshQua();
      }
      console.log('【CPublicSwitchGame】updateGame isRefreshClub = ', isRefreshClub);
      if (isRefreshClub) {
        this.refreshClub();
      }
      console.log('【CPublicSwitchGame】updateGame isRefreshRoleInfo = ', this.isRefreshRoleInfo && isRefreshRoleInfo);
      if (this.isRefreshRoleInfo && isRefreshRoleInfo) {
        setTimeout(() => {
          this.$store.commit('UPDATE_IS_ROLE_READY', false);
          this.checkRoleInfo();
        }, refreshRoleMs);
      }
    },
    async queryWhiteGameMap() {
      if (!this.isQueryWhiteGameMap) return {};
      const { queryWhiteGameMapFlowId } = this.configurationData;
      const response = await this.flowRequest({
        flowId: queryWhiteGameMapFlowId,
      });
      console.log('【CPublicSwitchGame】 query white game map response=', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0)  {
        this.$alert({ msg: msg || '查询游戏是否开放失败' });
        return {};
      }
      const { dataMap = {}, ret: resRet, msg: resMsg }  = data;
      if (resRet !== 0) {
        this.$alert({ msg: resMsg || '查询游戏是否开放失败' });
        return {};
      }
      return dataMap;
    },
    // 查询游戏列表
    async queryGameList() {
      const { queryGameListFlowId } = this.configurationData;
      if (queryGameListFlowId <= 0) return;
      const response = await this.flowRequest({
        flowId: queryGameListFlowId,
      });
      console.log('【CPublicSwitchGame】 query game list response=', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0)  {
        this.$alert({ msg: msg || '获取游戏列表失败' });
        return false;
      }
      const { list = [], ret: resRet }  = data;
      if (resRet !== 0) {
        this.$alert({ msg: '获取游戏列表失败' });
        return  false;
      }
      const gameList = list.map(e => ({
        ...e,
      }));
      return gameList;
    },
    showDialog() {
      this.handleClickEvent();
      this.isShow = true;
    },
    // 切换游戏
    switchGame() {
      console.log('【CPublicSwitchGame】 switch game code = ', this.switchGameCode);
      if (!this.switchGameCode) return;
      if (this.gameCode === this.switchGameCode) {
        this.isShow = false;
        return;
      }
      const gameItem = this.gameList.find(e => e?.game_code === this.switchGameCode) || {};
      console.log('【CPublicSwitchGame】switchGame isInWhiteGameMap = ', this.isInWhiteGameMap(gameItem?.gid), ', gid = ', gameItem?.gid);
      if (this.noInWhiteGameMapTips && !this.isInWhiteGameMap(gameItem?.gid)) {
        this.alert({ msg: this.noInWhiteGameMapTips });
        return;
      }
      this.handlerSelectedGame(gameItem);
      this.saveBindGame(gameItem);
      this.updateGame({ refreshRoleMs: 0, isRefreshRoleInfo: true });
      this.isShow = false;
    },
    // 查询绑定游戏
    async queryBindGame() {
      const { queryBindGameFlowId } = this.configurationData;
      if (queryBindGameFlowId <= 0) return;
      const response = await this.flowRequest({
        flowId: queryBindGameFlowId,
        params: {},
      });
      console.log('【CPublicSwitchGame】 query bind game response=', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0)  {
        this.$alert({ msg: msg || '查询游戏失败' });
        return;
      }
      const { content = '{}', ret: resRet }  = data;
      if (resRet !== 0) {
        this.$alert({ msg: '查询游戏失败' });
        return;
      }
      const gameInfo = content ?  JSON.parse(content) : {};
      this.handlerSelectedGame(gameInfo);
    },
    // 保存游戏
    async saveBindGame(game) {
      const { saveBindGameFlowId } = this.configurationData;
      if (saveBindGameFlowId <= 0) return;
      const response = await this.flowRequest({
        flowId: saveBindGameFlowId,
        params: {
          data: JSON.stringify({
            game_info: JSON.stringify(game),
          }),
        },
      });
      console.log('【CPublicSwitchGame】 save bind game response=', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0)  {
        this.$alert({ msg: msg || '绑定游戏失败' });
        return false;
      }
      const { ret: resRet, msg: resMsg }  = data;
      if (resRet !== 0) {
        this.$alert({ msg: resMsg || '绑定游戏失败' });
        return  false;
      }
    },
    // 刷新俱乐部绑定
    refreshClub() {
      this.$eventBus.$emit('ceiba:common:events:club-refresh', {});
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
